import React from "react";

import { useQuery, gql } from "@apollo/client";

import RbAutocompleteField from "components/RbAutocompleteField";

const productCategoryQuery = gql`
  query productCategoryList {
    productCategoryList {
      id
      name
    }
  }
`;

const ProductCategoryAutocomplete = (props) => {
  const { data: { productCategoryList = [] } = {} } = useQuery(
    productCategoryQuery
  );

  const getOptionLabel = React.useCallback((option) => option.name || "", []);

  const getOptionSelected = React.useCallback(
    (option, value) => option.id === value.id,
    []
  );

  return (
    <RbAutocompleteField
      options={productCategoryList}
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      {...props}
    />
  );
};

export default React.memo(ProductCategoryAutocomplete);
